export default __webpack_public_path__ + "static/media/FIGHT OR DIE 5.40844518.png";